"use client";

import React, { useCallback, useRef, useState } from "react";
import { AuthModal } from "@/components/shared/auth-modal";
import { useIsAuthenticated } from "@/hooks/use-auth";

export function useRequireAuth(returnTo?: string) {
  const isAuthenticated = useIsAuthenticated();
  const returnRef = useRef(returnTo);
  const [open, setOpen] = useState(false);

  const requireAuth = useCallback(() => {
    if (!isAuthenticated) {
      setOpen(true);
      return false;
    }
    return true;
  }, [isAuthenticated]);

  const withAuth = useCallback(<T extends unknown[]>(
    fn: (...args: T) => void,
    fallbackReturnTo?: string
  ) => {
    return (...args: T) => {
      if (!isAuthenticated) {
        returnRef.current = fallbackReturnTo || (typeof window !== "undefined" ? window.location.pathname : "/");
        setOpen(true);
        return;
      }
      fn(...args);
    };
  }, [isAuthenticated]);

  return {
    requireAuth,
    withAuth,
    open,
    setOpen,
    returnRef,
    AuthModal: () => (
      <AuthModal
        open={open}
        onOpenChange={setOpen}
        returnTo={returnRef.current}
      />
    ),
  };
}
